import {Header} from "./header/Header.tsx";
import {Footer} from "./footer/Footer.tsx";

import styles from './Layout.module.css'
import {useScreenDetector} from "@/hooks/useScreenDetector.ts";
import {Navigation} from "../../widgets/Navigation/Navigation.tsx";

interface Props {
    children: React.ReactNode,
}

export const Layout: React.FC<Props> = ({children}) => {
    const {isMobile} = useScreenDetector();

    return (
        <div className={styles.container}>
            <Header/>
            <main className='content'>
                {children}
            </main>
            <Footer/>

            {isMobile && (<Navigation />)}
        </div>
    )
}
